<template>
    <div>
        <b-modal
            no-close-on-esc
            no-close-on-backdrop
            size="xl"
            hide-footer
            v-model="showModal"
            :title="pageTitle"
            scrollable
        >
            <div v-if="loading" class="mb-3">
                <b-spinner
                    id="loadingSpinner"
                    small
                    style="align-self: center"
                    label="Loading"
                    variant="primary"
                />
            </div>
            <div v-else>
                <b-table
                    id="table-function-results"
                    striped
                    hover
                    small
                    outlined
                    bordered
                    :sticky-header="btableMaxHeight"
                    :select-mode="'single'"
                    tbody-tr-class="tablerow"
                    :items="functionResultsList"
                    :fields="functionResultFields"
                    sort-icon-left
                >
                    <template v-slot:cell(content)="{}">
                        <!-- Button to open modal with table content-->
                        <b-button
                            size="sm"
                            variant="secondary"
                            @click="$_refreshContent()"
                        >
                            {{ $t('functionResult.labelRefresh') }}
                        </b-button>
                    </template>
                </b-table>

                <div v-html="this.report"></div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import { functionResultName } from '../../services/utilities';
    export default {
        name: 'FunctionResultDetails',

        props: {
            launchModal: { type: Boolean, required: false, default: false },
            logRecordId: { type: Number, required: true, default: 0 },
            functionResult: { type: String, required: true, default: '' }
        },

        data() {
            return {
                showModal: false,
                loading: false,
                data: '',
                report: {},
                functionResultsList: [],
                functionResultFields: [
                    {
                        key: 'startDateTime',
                        label: this.$t('functionResult.startDateTime'),
                        sortable: true,
                        thStyle: { border: 0, width: '200px' }
                    },
                    {
                        key: 'endDateTime',
                        label: this.$t('functionResult.endDateTime'),
                        sortable: false,
                        thStyle: { border: 0, width: '200px' }
                    },
                    {
                        key: 'organizationName',
                        label: this.$t('functionResult.organizationName'),
                        sortable: false,
                        thStyle: { border: 0, width: '100x' }
                    },
                    {
                        key: 'userName',
                        label: this.$t('functionResult.userName'),
                        sortable: false,
                        thStyle: { border: 0, width: '100px' }
                    },
                    {
                        key: 'statusDescription',
                        label: this.$t('functionResult.statusDescription'),
                        sortable: false,
                        thStyle: { border: 0, width: '100px' }
                    },
                    {
                        key: 'status',
                        label: this.$t('functionResult.status'),
                        sortable: false,
                        thStyle: { border: 0, width: '100px' }
                    },
                    {
                        key: 'content',
                        label: '',
                        thStyle: { border: 0, width: '100px' }
                    }
                ],
                btableMaxHeight: `${(window.innerHeight - 300).toString()}px`
            };
        },
        computed: {
            pageTitle() {
                return this.functionResult ? functionResultName(this.functionResult) : '';
            }
        },

        methods: {
            async $_refreshContent() {
                await this.$_showDomainModal();
            },
            async $_showDomainModal() {
                this.Data = '';
                this.showModal = true;
                this.loading = true;

                // Get number of records
                let result = await this.$store.dispatch('useApiData', {
                    name: 'GetFunctionResult',
                    parameters: {
                        Id: this.logRecordId,
                        Function: this.functionResult
                    }
                });

                this.data = result.data;
                this.functionResultsList = [this.data];

                this.data.startDateTime = new Date(
                    this.data.startDateTime
                ).toLocaleString(this.$store.state.userInfo.locale);
                this.data.endDateTime = new Date(
                    this.data.endDateTime
                ).toLocaleString(this.$store.state.userInfo.locale);

                const dbReport = JSON.parse(this.data.report);
                this.report = '';
                let first = true;

                for (const [stepIndex, step] of dbReport.entries()) {
                    first = false;
                    if (stepIndex > 0) {
                        // Close previous list
                        this.report = this.report.concat('</table>');
                    }
                    this.report = this.report.concat(
                        `<h3 class="mt-2">${step.ProcessingStepName}</h3>`
                    );
                    for (const [
                        subIndex,
                        subStep
                    ] of step.ProcessingStepResults.entries()) {
                        if (subIndex == 0) {
                            this.report = this.report.concat('<table>');
                        }
                        this.report = this.report.concat(
                            `<tr><td>${subStep.ResultName}</td><td>${subStep.ResultValue}</td></tr>`
                        );
                    }
                }
                if (!first) {
                    this.report = this.report.concat('</table>');
                }
                this.loading = false;
            },

            $_hideModal() {
                this.showModal = false;
            }
        },

        watch: {
            launchModal() {
                this.$_showDomainModal();
            }
        }
    };
</script>
